import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { NavigationProvider } from '@app/contexts/NavigationContext';

interface NavigationWrapperProps {
  children: React.ReactNode;
}

export const NavigationWrapper: React.FC<NavigationWrapperProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <NavigationProvider navigate={navigate} location={location}>
      {children}
    </NavigationProvider>
  );
}; 